import { render, staticRenderFns } from "./SempcFooter.vue?vue&type=template&id=3a37d510&scoped=true&"
var script = {}
import style0 from "./SempcFooter.vue?vue&type=style&index=0&id=3a37d510&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a37d510",
  null
  
)

export default component.exports